import { TModalsIds } from "../../../../../../app/state/modalSlice/types";
import { RenameObjectInput } from "../../../../../../common/RenameObjectInput";
import { TEntityInfo } from "../../../../../../common/types/utility";
import { useAppSelector } from "../../../../../../services/redux/hooks/use-selector";
import { AppIconButton } from "../../../../../../shared/components/AppIconButton";
import { AppLoading } from "../../../../../../shared/components/AppLoading";
import { AppUnderlinedTitle } from "../../../../../../shared/components/AppUnderlinedTitle";
import { FileIcon } from "../../../../../../shared/icons/FileIcon";
import { selectUserArtifactGroup } from "../../../../../Auth/redux/selectors";
import { TMeetingRecognizeMeta } from "../../../../redux/types";
import styles from "./styles.module.css";

interface Props {
  openAttachedFileModal: (id: TModalsIds, info: TEntityInfo | null) => void;
  recognizeMeta: TMeetingRecognizeMeta | null;
}

export const MeetingHeader = ({
  openAttachedFileModal,
  recognizeMeta,
}: Props) => {
  const artifacts = useAppSelector(selectUserArtifactGroup);
  return (
    <AppUnderlinedTitle
      leftContent={
        <RenameObjectInput service={"meetings"} inputType={"input"} />
      }
    >
      <div className={styles["right-block-wrapper"]}>
        {artifacts && (
          <AppIconButton
            onClick={() => openAttachedFileModal("attached_file_modal", null)}
          >
            <FileIcon />
          </AppIconButton>
        )}
        {(recognizeMeta?.is_recognize || recognizeMeta?.is_file_loading) && (
          <AppLoading settingSize={16} className={styles["loader"]} />
        )}
      </div>
    </AppUnderlinedTitle>
  );
};
